import React from 'react';

import ProductPackageAdderButton from '../ProductPackage/ProductPackageAdderButton';
import ProductPackageAdderRoot from '../ProductPackage/ProductPackageAdderRoot';
import ProductAdderButton from './ProductAdderButton';
import ProductAdderRoot from './ProductAdderRoot';

const ProductAdderComponentSwitcher = (props: { showAsModal: boolean; packageId?: string }) => {
  const { showAsModal, packageId } = props;

  if (packageId) {
    return showAsModal ? <ProductPackageAdderButton /> : <ProductPackageAdderRoot />;
  }

  return showAsModal ? <ProductAdderButton /> : <ProductAdderRoot />;
};

export default ProductAdderComponentSwitcher;
